export const notesFiscalUpdateTypes = {
  SET_NOTES_FISCAL_UPDATE_FILTERS: 'SET_NOTES_FISCAL_UPDATE_FILTERS',
  GET_NOTES_FISCAL_UPDATE: 'GET_NOTES_FISCAL_UPDATE',
  SELECT_NOTE_TO_FISCAL_UPDATE: 'SELECT_NOTE_TO_FISCAL_UPDATE',
  DESELECT_NOTE_TO_FISCAL_UPDATE: 'DESELECT_NOTE_TO_FISCAL_UPDATE',
  DO_NOTES_FISCAL_UPDATE: 'DO_NOTES_FISCAL_UPDATE',
  SELECT_NEXT_NOTES_FISCAL_UPDATE: 'SELECT_NEXT_NOTES_FISCAL_UPDATE',
  CLEAR_NOTES_FISCAL_UPDATE: 'CLEAR_NOTES_FISCAL_UPDATE',
  SET_CONFIG_FILTER_NOTES_FISCAL_UPDATE: 'SET_CONFIG_FILTER_NOTES_FISCAL_UPDATE',
  SET_CONFIG_PAGE_NOTES_FISCAL_UPDATE: 'SET_CONFIG_PAGE_NOTES_FISCAL_UPDATE',
  SET_CONFIG_PAGE_SIZE_NOTES_FISCAL_UPDATE: 'SET_CONFIG_PAGE_SIZE_NOTES_FISCAL_UPDATE',
  SET_CONFIG_SORTED_NOTES_FISCAL_UPDATE: 'SET_CONFIG_SORTED_NOTES_FISCAL_UPDATE',
};